//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from "swiper";
export default {
  name: "recruit",
  data() {
    return {
      idx: 5,
      details: {},
      list1: [],
      banner: [],
      recruit_list: [],
      nav: [
        {
          text: "首页",
          status: "0",
        },
        {
          text: "关于中启",
          status: "1",
        },
        {
          text: "工程案例",
          status: "2",
        },
        {
          text: "新闻中心",
          status: "3",
        },
        {
          text: "业务中心",
          status: "4",
        },
        {
          text: "人力资源",
          status: "5",
        },
        {
          text: "联系我们",
          status: "6",
        },
      ],
    };
  },
  updated: function () {
    new Swiper(".swiper1", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  },
  mounted() {
    const _this = this;
    _this.getlist();
  },
  methods: {
    getlist() {
      const _this = this;
      var list = [];
      let Base64 = require("js-base64").Base64;
      var data = {
        pageNum: 1,
        pageSize: 1000,
      };
      _this.$post("/header/invite/list", data).then((res) => {
        _this.banner = res.data.bannerList;
        var a = res.data.pageInfo.list;
        for (let i = 0; i < a.length; i++) {
          res.data.pageInfo.list[i].html = Base64.decode(
            res.data.pageInfo.list[i].newContent
          );
          list.push(res.data.pageInfo.list[i]);
        }
        _this.list1 = list;
        console.log(list);
      });
    },
    collect_click() {
      alert("请按住Ctrl+D收藏网站");
    },
    //导航跳转
    rout(a) {
      if (a == 0) {
        this.$router.push({
          path: "/",
        });
      } else if (a == 1) {
        this.$router.push({
          path: "/about",
        });
      } else if (a == 2) {
        this.$router.push({
          path: "/project",
        });
      } else if (a == 3) {
        this.$router.push({
          path: "/new",
        });
      } else if (a == 4) {
        this.$router.push({
          path: "/business",
        });
      } else if (a == 5) {
        this.$router.push({
          path: "/recruit",
        });
      } else if (a == 6) {
        this.$router.push({
          path: "/contact",
        });
      }
    },
    //tab点击事件
    tab_click(a) {
      const _this = this;
      _this.goodsstatus = a;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/recruit.vue